import React, { useContext, useEffect, useState } from "react";
import { AuthContext } from "../context/AuthContext";

import { db, serverTime } from "../Utils/firebase";

function Message() {
  const { userData, userAuth, setUserData } = useContext(AuthContext);
  const [disable, setDisable] = useState(true);
  const [message, setMessage] = useState(userData.message);
  const [btnText, setBtnText] = useState("Save");
  const [char, setChar] = useState(userData.message.length);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);
  const [mount, setMount] = useState(true);

  const handleChange = (e) => {
    if (
      e.target.value.length > e.target.maxLength &&
      e.keyCode !== 46 &&
      e.keyCode !== 8
    ) {
      e.preventDefault();
    } else {
      setMessage(e.target.value);
    }
  };

  const handleChar = (e) => {
    if (
      e.target.value.length > e.target.maxLength &&
      e.keyCode !== 46 &&
      e.keyCode !== 8
    ) {
      e.preventDefault();
    } else {
      setChar(e.target.value.length);
      setDisable(false);
      setBtnText("Save");
    }
  };

  const handleBlur = () => {
    if (message === userData.message) {
      setDisable(true);
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setDisable(true);
    setBtnText("Saving ... ");

    const messageTrim = message.replace(/(\r\n|\n|\r)/gm, " ");

    if (message === userData.message) {
      setBtnText("Save");
    } else {
      setLoading(true);
      db.collection("user")
        .doc(userAuth.uid)
        .update({
          message: messageTrim.toString(),
          updateAt: serverTime,
        })
        .then(() => {
          db.collection("user")
            .doc(userAuth.uid)
            .get()
            .then((doc) => {
              setUserData(doc.data());
              if (mount) {
                setBtnText("Saved");
                setMessage(messageTrim);
                setLoading(false);
              }
            })
            .catch((error) => {
              if (mount) {
                setError(error);
                setMessage(messageTrim);
                setLoading(false);
              }
            });
        })
        .catch((error) => {
          if (mount) {
            setError(error);
            setMessage(messageTrim);
            setLoading(false);
          }
        });
    }
  };

  useEffect(() => {
    return () => {
      setMount(false);
    };
  }, [mount]);

  return (
    <div className="message divContent darktextColor darkdivColor">
      <div className="head-tab">
        <h5 className="textTitle textMedium">Message</h5>
        <p className="textSmall">{char} / 80</p>
      </div>
      <form
        className="form-message"
        onSubmit={handleSubmit}
        onBlur={handleBlur}
      >
        <textarea
          className="input-area text lighttextColor textMedium"
          maxLength="80"
          placeholder="Share more information about you like yourwebsite, address, etc"
          value={message}
          onChange={handleChange}
          onKeyUp={handleChar}
          disabled={loading}
        ></textarea>

        <button
          className={
            disable
              ? "btn-in darktextColor textTitle disable"
              : "btn-in darktextColor textTitle "
          }
          disabled={disable}
          type="submit"
        >
          {btnText}
        </button>
      </form>
      {error ? (
        <p className="error-message text textMedium darktextColor">
          Terjadi Kesalahan , cobalah beberapa saat lagi!
        </p>
      ) : null}
    </div>
  );
}

export default Message;
